/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop, RadialGradient, Circle } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstRecordedMusicBookingUnlockedDetailedSvg({
  size,
  accessibilityLabel,
  testID,
}: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 260 260"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M238.706 215.558C238.706 215.558 139.545 254.796 130.655 254.796C121.764 254.796 22.3743 215.956 22.3743 215.956C18.0326 215.962 17.8004 48.9266 22.1453 48.9203C22.1453 48.9203 124.573 5 130.658 5C136.743 5 238.48 48.5227 238.48 48.5227C240.474 48.5227 240.703 215.555 238.709 215.558H238.706Z"
          fill="url(#paint0_linear_8631_22448)"
        />
        <Path
          d="M130.658 254.8C139.548 254.8 238.709 215.561 238.709 215.561C240.703 215.561 240.474 48.5226 238.48 48.5258C238.48 48.5258 136.743 5.00317 130.658 5.00317V254.803V254.8Z"
          fill="url(#paint1_linear_8631_22448)"
        />
        <Path
          d="M234.571 54.7379C234.571 54.7379 136.482 12.4812 130.616 12.4812C124.751 12.4812 25.9941 55.1228 25.9941 55.1228C21.805 55.1291 22.0277 217.298 26.2168 217.292C26.2168 217.292 122.044 255 130.616 255C139.189 255 234.793 216.904 234.793 216.904C236.715 216.904 236.495 54.7315 234.571 54.7347V54.7379ZM226.075 210.081C226.075 210.081 138.483 244.984 130.629 244.984C122.776 244.984 34.9798 210.434 34.9798 210.434C31.1438 210.44 30.9403 61.8597 34.7763 61.8565C34.7763 61.8565 125.257 22.7901 130.629 22.7901C136.002 22.7901 225.871 61.5034 225.871 61.5034C227.634 61.5034 227.837 210.081 226.075 210.081Z"
          fill="#BCB6C3"
        />
        <Path
          d="M238.477 48.5227C238.477 48.5227 136.739 5 130.658 5C124.576 5 22.1453 48.9203 22.1453 48.9203C17.8035 48.9266 18.0326 215.962 22.3743 215.956C22.3743 215.956 121.764 254.796 130.655 254.796C139.545 254.796 238.706 215.558 238.706 215.558C240.7 215.558 240.471 48.5195 238.477 48.5227ZM229.663 208.529C229.663 208.529 138.813 244.481 130.667 244.481C122.521 244.481 31.4618 208.895 31.4618 208.895C27.4827 208.901 27.2727 55.8639 31.2519 55.8575C31.2519 55.8575 125.095 15.6175 130.667 15.6175C136.24 15.6175 229.453 55.4918 229.453 55.4918C231.279 55.4918 231.492 208.526 229.663 208.529Z"
          fill="url(#paint2_linear_8631_22448)"
        />
        <Path
          d="M47.7219 70.311V198.605C47.7219 198.678 47.7665 198.745 47.8301 198.773L106.143 224.29C106.729 224.547 107.244 223.809 106.799 223.348L67.7259 182.726C67.7004 182.701 67.6845 182.666 67.6782 182.631L48.0877 70.2792C48.0495 70.0597 47.7251 70.0852 47.7251 70.311H47.7219Z"
          fill="#E3DEED"
        />
        <Path
          d="M209.713 70.311V198.605C209.713 198.678 209.668 198.745 209.605 198.773L151.291 224.29C150.706 224.547 150.191 223.809 150.636 223.348L189.709 182.726C189.734 182.701 189.75 182.666 189.757 182.631L209.347 70.2792C209.385 70.0597 209.71 70.0852 209.71 70.311H209.713Z"
          fill="#EFEEF0"
        />
        <Path
          d="M239.772 136.819C240.885 134.948 237.651 133.993 235.81 134.217C235.55 134.246 234.999 134.47 234.261 134.812C234.999 134.461 235.54 134.246 235.81 134.217L214.024 133.476C214.19 135.318 214.128 137.248 214.003 139.188C214.024 138.437 214.065 137.687 214.065 136.936C214.065 93.894 176.836 59 130.912 59C84.9887 59 49.7557 92.0615 47.8422 133.515L26.6483 134.227C24.7141 134.119 22.551 134.636 23.0814 136.829C23.4245 136.663 23.7261 136.595 23.9965 136.615C23.7365 136.595 23.4349 136.663 23.0814 136.829L46.8543 220.185C47.2078 220.74 48.0086 221.052 48.435 221.481C51.3364 224.376 55.9329 225.243 60.1238 225.565C97.0623 228.421 146.272 226.247 184.115 225.565C191.27 225.438 210.956 226.744 214.814 221.666C224.309 193.819 231.183 165.007 239.772 136.829C239.388 136.985 239.024 137.161 238.66 137.346C239.024 137.161 239.388 136.985 239.762 136.829L239.772 136.819ZM235.894 138.925C235.602 139.09 235.311 139.266 235.02 139.422C235.727 139.695 235.998 140.085 236.039 140.543C235.998 140.085 235.727 139.704 235.02 139.432C235.322 139.276 235.613 139.1 235.904 138.934L235.894 138.925ZM191.052 219.619L205.871 170.719L191.052 219.629V219.619ZM213.577 145.406C213.577 145.387 213.577 145.377 213.577 145.358C213.577 145.367 213.577 145.387 213.577 145.397V145.406ZM37.0061 139.12C37.8172 139.578 38.5972 140.026 39.3147 140.436C40.3963 141.059 41.3426 141.615 42.0602 142.024C42.2994 142.161 42.5073 142.287 42.6945 142.385C44.192 143.233 46.0847 144.383 48.2998 145.757C46.0847 144.383 44.192 143.243 42.6945 142.385C42.5177 142.278 42.2994 142.161 42.0602 142.024C41.3426 141.615 40.3963 141.059 39.3147 140.436C38.5972 140.016 37.8172 139.568 37.0061 139.12C35.7998 138.437 34.5206 137.726 33.2935 137.073C34.531 137.726 35.7998 138.437 37.0061 139.12ZM48.6326 220C49.9741 220.048 51.3156 220.068 52.6571 220.078C51.3156 220.068 49.9741 220.039 48.6326 220ZM190.646 220C148.685 219.834 106.619 219.736 64.6683 220L54.5082 167.756C54.5082 167.756 54.5082 167.756 54.5082 167.766L64.6683 219.99C106.609 219.727 148.674 219.824 190.646 219.99H191.041C198.362 220.019 190.646 219.99 190.646 219.99V220ZM235.415 144.061C235.394 143.954 235.384 143.847 235.374 143.73C235.374 143.837 235.394 143.944 235.415 144.061ZM238.462 137.443C238.462 137.443 238.514 137.414 238.535 137.404C238.514 137.414 238.483 137.433 238.462 137.443Z"
          fill="#7F8AA5"
        />
        <Circle cx="130.764" cy="127.965" r="79.9649" fill="#D9D9D9" />
        <Circle cx="130.764" cy="127.965" r="79.9649" fill="url(#paint3_radial_8631_22448)" />
        <Circle cx="130.764" cy="127.965" r="74.5704" fill="url(#paint4_radial_8631_22448)" />
        <Path
          d="M54.5047 144.225L67.0769 213.176C61.949 213.211 56.8179 213.36 51.6488 213.176L51.4584 214.699C51.0427 214.258 50.2716 213.931 49.9352 213.366L27.0786 127.845C28.8651 126.915 29.3221 129.149 30.3153 129.749C38.334 134.588 46.5145 139.167 54.5047 144.225Z"
          fill="#B7DAEC"
        />
        <Path
          d="M51.4583 214.699L51.6486 213.176C56.8178 213.36 61.9489 213.211 67.0768 213.176C107.411 212.909 147.86 213.004 188.214 213.176C188.214 213.176 195.636 213.207 188.595 213.176V212.795L210.69 212.224L231.262 135.273C230.91 133.5 233.051 131.408 230.881 130.51C232.401 129.635 233.829 128.546 235.454 127.845C227.194 156.759 220.587 186.324 211.455 214.889C207.742 220.1 188.814 218.757 181.931 218.891C145.538 219.586 98.2218 221.823 62.6978 218.891C58.6741 218.557 54.2538 217.669 51.4614 214.699H51.4583Z"
          fill="#4665B6"
        />
        <Path
          d="M30.5056 125.179C32.9553 125.325 43.1413 131.862 45.9337 133.56C60.2544 142.277 112.701 180.669 124.407 181.939C131.226 182.678 141.016 182.224 147.264 179.273C168.366 169.3 195.325 146.852 216.405 133.941C218.683 132.544 230.1 125.379 231.643 125.179C233.413 124.948 236.517 125.928 235.45 127.845C233.826 128.549 232.401 129.638 230.878 130.51C221.923 135.657 213.044 140.944 204.594 146.891C178.238 159.355 151.31 193.53 119.835 185.746C97.5777 172.927 76.2918 158.016 54.5046 144.225C46.5144 139.167 38.3307 134.591 30.3152 129.749C29.322 129.149 28.8651 126.915 27.0785 127.845C26.5677 125.595 28.6461 125.068 30.5056 125.179Z"
          fill="#E5ECFD"
        />
        <Path
          d="M51.8391 124.418C51.4932 128.181 51.5987 131.795 51.751 135.581C52.0525 136.444 56.2467 138.266 57.1733 138.891C57.938 139.405 58.6964 139.903 59.458 140.414C67.7813 145.973 76.1522 151.425 84.5993 156.794C93.662 162.554 102.296 169.401 112.029 173.936C125.356 180.146 133.724 180.803 147.457 175.078C151.072 173.571 153.991 171.613 157.361 169.744C158.043 169.366 158.618 168.973 159.265 168.602C168.007 163.594 176.283 157.971 184.787 152.602C187.64 150.8 190.346 148.664 193.167 146.887C194.402 146.11 195.725 145.38 196.975 144.603C198.997 143.343 201.037 142.016 203.071 140.795C203.88 140.309 204.588 139.722 205.356 139.272C207.212 138.183 209.157 137.212 211.071 136.225C212.714 135.375 214.52 134.163 216.405 133.941C195.325 146.852 168.366 169.3 147.264 179.273C141.016 182.224 131.226 182.678 124.407 181.939C112.701 180.669 60.2544 142.277 45.9338 133.56C43.1413 131.862 32.9553 125.325 30.5056 125.179L51.8391 124.418Z"
          fill="#21232A"
        />
        <Path
          d="M231.642 125.179C230.1 125.379 218.683 132.548 216.405 133.941C214.52 134.163 211.896 135.841 210.253 136.691C210.402 132.725 211.032 128.362 210.69 124.415L231.642 125.176V125.179Z"
          fill="#030406"
        />
        <Path
          d="M204.597 146.891C205.73 147.405 206.517 145.145 207.263 147.081L188.598 212.792V213.173C188.471 213.173 188.344 213.173 188.217 213.173C147.864 213.001 107.412 212.906 67.0801 213.173L54.5078 144.222C76.2951 158.013 97.581 172.924 119.838 185.743C151.313 193.527 178.241 159.352 204.597 146.887V146.891Z"
          fill="url(#paint5_linear_8631_22448)"
        />
        <Path
          d="M188.598 212.795L207.263 147.084C206.517 145.148 205.73 147.408 204.597 146.894C213.051 140.947 221.926 135.661 230.881 130.514C233.052 131.412 230.91 133.503 231.262 135.277L210.69 212.227L188.595 212.798L188.598 212.795Z"
          fill="#4665B6"
        />
        <Path
          d="M92.7861 69.5999C97.747 80.548 107.168 92.4358 113.883 102.489C110.758 104.679 106.841 109.59 104.867 112.856C103.948 114.377 102.238 117.144 101.729 118.735L63.3014 105.402L63.2824 105.021C68.4051 93.7401 75.4443 82.8555 85.215 74.5539C87.3056 72.7781 90.1778 70.2387 92.7859 69.5967L92.7861 69.5999Z"
          fill="#F3ECEB"
        />
        <Path
          d="M184.787 152.605C176.283 157.978 168.007 163.597 159.265 168.605L148.6 154.509C154.28 150.949 158.748 145.047 161.172 138.891L184.79 152.605H184.787Z"
          fill="#B7DAEC"
        />
        <Path
          d="M112.029 152.225C114.243 153.999 117.763 156.223 120.409 157.178L112.029 173.939C102.3 169.404 93.6621 162.557 84.5994 156.797L105.362 145.371C107.634 147.652 109.487 150.194 112.029 152.228V152.225Z"
          fill="#F3ECEB"
        />
        <Path
          d="M157.361 169.747C153.991 171.616 151.072 173.574 147.458 175.081L142.885 157.178C143.726 156.899 144.421 156.372 145.17 156.036C146.055 155.639 146.972 155.395 147.835 154.893L157.358 169.75L157.361 169.747Z"
          fill="#B7DAEC"
        />
        <Path
          d="M196.979 144.606C195.728 145.383 194.405 146.113 193.171 146.891L162.314 136.987C162.429 136.584 162.613 135.867 162.695 135.464L196.979 144.606Z"
          fill="#92C3FF"
        />
        <Path
          d="M110.886 63.4668L121.551 98.8957C117.848 100.06 115.367 101.958 112.409 104.23C111.949 104.582 110.95 104.938 110.886 104.991L91.0759 69.9465C91.2029 69.8545 92.4087 68.1505 93.1702 67.6618C97.9269 64.6155 103.309 62.4514 108.408 60.043L110.455 59.4236C111.017 59.9091 110.138 63.3393 111.407 63.0727L110.886 63.4668Z"
          fill="#F3ECEB"
        />
        <Path
          d="M64.0305 106.131L100.031 121.368L100.221 123.843C99.691 124.332 88.9655 121.118 87.2679 120.607C87.1282 120.566 84.0954 119.711 83.007 119.397C75.3722 117.185 68.9941 115.732 61.2705 113.844L61.7465 111.147C62.3811 108.767 61.9806 106.296 64.0305 106.131Z"
          fill="#F3ECEB"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.886 104.988L91.076 69.9433C90.9866 70.008 90.8602 69.8956 90.7178 69.7689C90.5317 69.6033 90.3182 69.4133 90.1241 69.5626C89.7052 69.8831 87.284 71.8473 87.2682 72.0377L110.506 105.369L110.499 105.363C106.885 108.653 103.718 113.397 101.928 117.935L66.8835 99.2701C65.2524 99.2321 63.2311 104.744 64.0276 106.127L100.028 121.365L100.218 123.84C99.6849 124.329 88.9626 121.118 87.265 120.604L61.1717 113.746C58.576 122.327 58.741 131.542 59.4582 140.411C67.7815 145.97 76.1524 151.422 84.5995 156.791L105.362 145.364C106.187 146.193 106.958 147.056 107.726 147.917L107.726 147.917C109.072 149.425 110.411 150.925 112.026 152.219L112.029 152.225C114.244 153.998 117.763 156.226 120.409 157.178L112.029 173.939C125.356 180.149 133.727 180.806 147.458 175.081L142.885 157.178C143.387 157.011 143.835 156.757 144.275 156.507C144.573 156.338 144.866 156.171 145.17 156.036L144.027 151.844C134.219 156.746 122.113 155.848 113.552 148.798C113.275 149.206 112.953 149.521 112.659 149.809C112.144 150.314 111.716 150.733 111.776 151.413C111.715 150.732 112.143 150.311 112.66 149.804C112.953 149.517 113.275 149.201 113.552 148.794C100.523 138.066 101.04 116.878 114.694 106.892L112.409 104.227C112.09 104.472 111.509 104.717 111.163 104.862C111.012 104.926 110.906 104.971 110.886 104.988ZM148.289 102.49C146.773 101.465 144.342 99.8211 142.885 99.2733H142.888C136.167 96.7411 128.361 96.7506 121.555 98.8925C117.852 100.057 115.37 101.955 112.413 104.227L114.697 106.892C124.392 99.8033 137.395 100 147.077 106.892L148.6 102.7L148.289 102.49Z"
          fill="url(#paint6_radial_8631_22448)"
        />
        <Path
          d="M192.406 92.8C181.224 97.2076 168.88 106.023 158.504 112.226C156.473 108.996 151.764 104.839 148.6 102.704C147.128 101.71 144.449 99.8636 142.885 99.2765L158.123 61.5629H158.504C169.515 67.243 180.034 74.8174 187.837 84.9907C189.506 87.1675 191.898 90.1631 192.409 92.8H192.406Z"
          fill="url(#paint7_linear_8631_22448)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M199.263 104.801C197.959 101.123 196.779 98.6922 193.548 92.8L193.545 92.8032C193.026 92.4529 192.978 92.4825 192.763 92.6167L192.763 92.6167C192.68 92.6685 192.573 92.736 192.403 92.8032C184.244 96.0198 175.464 101.582 167.281 106.766L167.281 106.766L167.281 106.766L167.281 106.766C164.253 108.684 161.307 110.551 158.504 112.227C158.504 112.227 158.504 112.227 158.504 112.226V112.22C156.476 108.99 151.767 104.833 148.6 102.697L147.077 106.889C162.927 118.176 161.604 143.057 144.031 151.841L145.173 156.033C145.502 155.885 145.836 155.759 146.17 155.632C146.732 155.419 147.295 155.206 147.836 154.891L157.358 169.747C157.729 169.541 158.069 169.33 158.408 169.121L158.408 169.12L158.408 169.12C158.689 168.946 158.968 168.773 159.262 168.605L148.598 154.511C148.599 154.51 148.599 154.51 148.6 154.509C154.28 150.949 158.747 145.048 161.172 138.892L184.787 152.605C186.204 151.71 187.584 150.732 188.961 149.757C190.356 148.769 191.747 147.784 193.168 146.891L162.314 136.988C162.314 136.988 162.314 136.987 162.315 136.987C162.428 136.588 162.612 135.871 162.695 135.468L196.975 144.609C197.727 144.142 198.482 143.664 199.238 143.187L199.238 143.187L199.238 143.186C200.514 142.38 201.794 141.57 203.071 140.801C204.21 128.572 203.376 116.412 199.263 104.801Z"
          fill="url(#paint8_radial_8631_22448)"
        />
        <Path
          d="M158.123 61.5629L142.885 99.2765C136.164 96.7443 128.361 96.7538 121.551 98.8957L110.886 63.4668C108.459 58.4119 111.127 59.202 115.078 58.1327C129.389 54.2582 144.592 55.886 158.126 61.5597L158.123 61.5629Z"
          fill="url(#paint9_linear_8631_22448)"
        />
        <Path
          d="M147.074 106.892C162.921 118.176 161.597 143.057 144.027 151.844C134.219 156.746 122.113 155.845 113.552 148.798C100.523 138.066 101.04 116.881 114.694 106.895C124.388 99.8064 137.392 100.003 147.074 106.895V106.892Z"
          fill="url(#paint10_linear_8631_22448)"
        />
        <Path
          d="M136.789 115.273C116.433 108.057 109.411 137.701 127.647 141.556C128.256 145.304 123.192 142.204 121.742 141.176C115.818 136.981 113.695 128.654 116.217 121.94C118.981 114.581 130.621 108.583 136.789 115.273Z"
          fill="#C4C3C2"
        />
        <Path
          d="M134.504 141.559C147.023 139.03 149.64 122.066 138.312 116.037C138.588 114.705 140.527 114.613 141.168 115.276C141.463 115.26 144.795 119.033 145.169 119.658C148.987 126.081 147.968 134.985 142.314 140.04C140.736 141.452 134.311 145.716 134.504 141.563V141.559Z"
          fill="#F3ECEB"
        />
        <Path
          d="M136.789 115.273C137.278 115.447 137.843 115.783 138.312 116.034C149.64 122.063 147.019 139.03 134.504 141.556C131.931 142.077 130.224 142.102 127.647 141.556C109.414 137.701 116.433 108.057 136.789 115.273Z"
          fill="#949298"
        />
        <Path
          d="M130.503 118.322C144.189 117.151 144.151 135.886 132.788 136.987C119.514 138.275 118.048 119.388 130.503 118.322Z"
          fill="#030406"
        />
        <Path
          d="M49.3318 64.0425C48.7645 63.653 48.789 64.8061 48.6663 65.0423C45.6762 70.7618 44.4311 74.0341 38 76.9292C44.3575 79.6095 45.7989 83.9491 48.6663 89.4846C48.7675 89.684 48.7737 90.6562 49.3318 90.2636C51.0554 84.0533 54.5147 79.8825 60.219 76.9322C54.5024 74.1721 51.3743 69.9921 49.3318 64.0455V64.0425Z"
          fill="#7F8AA5"
        />
        <Path
          d="M49.9668 87.5218C50.1109 85.7063 50.5771 82.8081 50.1876 81.0785C50.5372 80.9313 50.3256 80.6307 50.6323 80.1891C52.4386 77.5946 53.1931 75.9354 56.4101 74.7455C53.4445 74.31 52.365 71.7462 50.4115 69.9675C50.4053 69.8202 50.4176 69.67 50.4115 69.5228C50.3133 67.3913 50.7856 65.036 49.9668 63.0794C50.0895 62.8433 50.0649 61.6902 50.6323 62.0796C52.6778 68.0262 55.8029 72.2062 61.5194 74.9663C55.8121 77.9166 52.3558 82.0905 50.6323 88.2977C50.0711 88.6933 50.068 87.7181 49.9668 87.5187V87.5218Z"
          fill="#A6C2FF"
        />
        <Path
          d="M50.4082 69.5228C49.0098 71.7646 47.1605 73.4882 44.8543 74.7456C46.8017 75.8619 49.6906 78.8612 50.1874 81.0785C50.5738 82.8082 50.1108 85.7063 49.9666 87.5219C47.1022 81.9863 45.6578 77.6498 39.3003 74.9664C45.7314 72.0683 46.9765 68.796 49.9666 63.0795C50.7855 65.0361 50.3132 67.3914 50.4113 69.5228H50.4082Z"
          fill="#85ABFF"
        />
        <Path
          d="M50.4086 69.9676C50.5374 73.3687 50.9545 76.736 50.6294 80.1892C50.3227 80.6308 50.5343 80.9314 50.1847 81.0786C49.6879 78.8613 46.799 75.862 44.8516 74.7456C47.1578 73.4913 49.0101 71.7647 50.4055 69.5229C50.4117 69.6701 50.3994 69.8204 50.4055 69.9676H50.4086Z"
          fill="#5E89E7"
        />
        <Path
          d="M50.6322 80.1892C50.9542 76.739 50.5371 73.3686 50.4114 69.9675C52.368 71.7432 53.4444 74.307 56.41 74.7456C53.193 75.9355 52.4385 77.5977 50.6322 80.1892Z"
          fill="#D8E4FF"
        />
        <Path
          d="M83.8883 45.3095C85.1916 48.5112 86.5932 50.3636 90.0004 51.4216C86.3264 52.5656 84.9586 54.746 83.6674 58.1993C83.2994 54.5283 80.9319 52.86 78 51.2008C81.5146 50.5384 82.8026 48.4591 83.8883 45.3126V45.3095Z"
          fill="#7F8AA5"
        />
        <Path
          d="M84.7686 44C86.072 47.2017 87.4735 49.0541 90.8807 50.1121C87.2067 51.256 85.8389 53.4365 84.5478 56.8898C84.1798 53.2188 81.8122 51.5505 78.8804 49.8913C82.3949 49.2289 83.683 47.1496 84.7686 44.0031V44Z"
          fill="#C58CF0"
        />
        <Path
          d="M197.741 54.9439C199.675 59.6967 201.756 62.4463 206.814 64.0169C201.36 65.715 199.329 68.9517 197.413 74.0778C196.867 68.6285 193.352 66.152 189 63.6891C194.217 62.7058 196.129 59.6193 197.741 54.9485V54.9439Z"
          fill="#7F8AA5"
        />
        <Path
          d="M199.047 53C200.982 57.7527 203.062 60.5024 208.12 62.073C202.666 63.771 200.636 67.0078 198.719 72.1338C198.173 66.6846 194.658 64.2081 190.306 61.7452C195.523 60.7619 197.435 57.6753 199.047 53.0045V53Z"
          fill="#C58CF0"
        />
        <Path
          d="M134.888 228.31C136.192 231.511 137.593 233.364 141 234.422C137.326 235.566 135.959 237.746 134.667 241.199C134.299 237.528 131.932 235.86 129 234.201C132.515 233.538 133.803 231.459 134.888 228.313V228.31Z"
          fill="#7F8AA5"
        />
        <Path
          d="M135.768 227C137.072 230.202 138.473 232.054 141.88 233.112C138.206 234.256 136.838 236.437 135.547 239.89C135.179 236.219 132.812 234.55 129.88 232.891C133.394 232.229 134.682 230.15 135.768 227.003V227Z"
          fill="#F4E5FF"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_22448"
            x1="129.548"
            y1="5"
            x2="129.548"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_22448"
            x1="185.376"
            y1="5.00317"
            x2="185.376"
            y2="254.803"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_22448"
            x1="129.547"
            y1="5"
            x2="129.547"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <RadialGradient
            id="paint3_radial_8631_22448"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(133.656 127.965) rotate(-90) scale(85.8353)">
            <Stop offset="0.79" stopColor="#E3EAFF" />
            <Stop offset="1" stopColor="#9E82EA" />
          </RadialGradient>
          <RadialGradient
            id="paint4_radial_8631_22448"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(133.461 127.965) rotate(-89.58) scale(108.209)">
            <Stop stopColor="#E3EAFF" />
            <Stop offset="1" stopColor="#7E9FF8" />
          </RadialGradient>
          <LinearGradient
            id="paint5_linear_8631_22448"
            x1="72.6943"
            y1="208.247"
            x2="200.416"
            y2="170.645"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#5776C9" />
          </LinearGradient>
          <RadialGradient
            id="paint6_radial_8631_22448"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(130.764 127.648) rotate(179.21) scale(69.0239 56.4781)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <LinearGradient
            id="paint7_linear_8631_22448"
            x1="185.895"
            y1="85.8475"
            x2="147.448"
            y2="87.3072"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#91CDFF" />
            <Stop offset="1" stopColor="#CEEBFF" />
          </LinearGradient>
          <RadialGradient
            id="paint8_radial_8631_22448"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(131.399 127.648) rotate(-3.45332) scale(55.3143 48.0593)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#5B7EDD" />
          </RadialGradient>
          <LinearGradient
            id="paint9_linear_8631_22448"
            x1="151.897"
            y1="77.5781"
            x2="114.564"
            y2="77.7494"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#9E82EA" />
            <Stop offset="1" stopColor="#DCA1FC" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_8631_22448"
            x1="107.301"
            y1="127.734"
            x2="153.763"
            y2="128.825"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBFAFA" />
            <Stop offset="1" stopColor="#C9C7C6" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstRecordedMusicBookingUnlockedDetailed = styled(
  FirstRecordedMusicBookingUnlockedDetailedSvg
).attrs(({ size, theme }) => ({
  size: size ?? theme.illustrations.sizes.fullPage,
}))``
